import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SparkCoreModule } from '@core/core.module';
import { LoadModule } from '@shared/components/load/load.module';
import { MenuModule } from '@shared/components/menu/menu.module';
import { SparkPlusModalModule } from '@shared/components/modal/modal.module';
import { SummaryCardModule } from '@shared/components/summary/summary-card/summary-card.module';
import { SummaryFieldModule } from '@shared/components/summary-field/summary-field.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { SharedModule } from '@shared/shared.module';

import { DiaryNoteDisplayCreatedDatePipe } from './pipes/diary-note-display-created-date.pipe';
import { DiaryNoteContextMenuPipe } from './pipes/diary-note-context-menu.pipe';
import { DiaryNoteEditComponent } from './views/custom/common/edit/diary-note-edit.component';
import { DiaryNoteNewComponent } from './views/custom/common/new/diary-note-new.component';
import { OpportunityDiaryNoteEditComponent } from './views/custom/opportunity/edit/opportunity-diary-note-edit.component';
import { OpportunityDiaryNoteNewComponent } from './views/custom/opportunity/new/opportunity-diary-note-new.component';
import { DiaryNoteListComponent } from './views/list/diary-note-list.component';
import { AgpSharedAggregatorComponentRegistryModule } from '@liberty-financial/agp-shared';

@NgModule({
  declarations: [
    DiaryNoteDisplayCreatedDatePipe,
    DiaryNoteContextMenuPipe,
    DiaryNoteEditComponent,
    DiaryNoteNewComponent,
    DiaryNoteListComponent,
    OpportunityDiaryNoteEditComponent,
    OpportunityDiaryNoteNewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoadModule,
    ReactiveFormsModule,
    SparkPlusModalModule,
    LoadModule,
    MenuModule,
    PipesModule,
    SummaryFieldModule,
    SummaryCardModule,
    SparkCoreModule,
    AgpSharedAggregatorComponentRegistryModule
  ],
  exports: [DiaryNoteListComponent],
  providers: []
})
export class DiaryNotesModule {}
